// extracted by mini-css-extract-plugin
export default {"Table":"table_Table__rybBZ","Row":"table_Row__nynnN","Header":"table_Header__Xm5-u","Body":"table_Body__Y4kuU","Cell":"table_Cell__GvBOV","Message":"table_Message__Z8m7z"};